var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddress = function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#303030",
    d: "m20.3 10.285-4.217-3.392v-2.31a1.75 1.75 0 0 0-1.659-1.833H3.974a1.75 1.75 0 0 0-1.64 1.833v9.167a1.83 1.83 0 0 0 1.1 1.723 2.75 2.75 0 1 0 5.132.11h5.83a2.75 2.75 0 1 0 5.17 0h.184a.916.916 0 0 0 .916-.916V11a.92.92 0 0 0-.366-.715m-1.467 1.155v2.31h-2.75V9.24zM6.916 16.5a.917.917 0 1 1-1.833 0 .917.917 0 0 1 1.833 0m4.584-2.75H4.166V4.583H14.25v9.167zm6.416 2.75a.917.917 0 1 1-1.834 0 .917.917 0 0 1 1.834 0"
  })));
};
export default SvgAddress;